import { Center, Text, VStack } from '@chakra-ui/react';

import { BowerNestLoader } from '../ui/BowerNestLoader';

/**
 * The app's first loading screen: route Suspense fallbacks and the auth and
 * workspace boot waits in `App.tsx` all render this.
 *
 * The pre-JavaScript splash in `index.html` is drawn to sit exactly where this
 * puts its loader (a 50vh centred column, a 6rem mark, a 1rem gap, one line of
 * text), so React's first render takes over in place. Change the layout here
 * and the splash's generator (`scripts/generate-nest-loader.mjs`) has to
 * follow; `nestLoader.test.tsx` fails until it does.
 */
export const LoadingFallback = () => (
  <Center height="50vh">
    <VStack spacing={4}>
      <BowerNestLoader size="lg" />
      <Text color="text.secondary">Loading...</Text>
    </VStack>
  </Center>
);
